export const IS_DEV = process.env.NODE_ENV === 'development';
export const API_URL = process.env.REACT_APP_API_URL || 'https://product.velomatch.io';
export const IS_PROD = process.env.REACT_APP_ENV === 'production';
export const IS_DEV_CUSTOM = process.env.REACT_APP_ENV === 'development';